import React from "react";
// reactstrap components

// core components
import ColorNavbar from "../components/Navbars/ColorNavbar.js";
// sections for this page
import HomePageHeader from "../components/Headers/HomePageHeader.js";
import SectionHeader from "../components/sections/SectionHeader.js";
import SectionFeature from "../components/sections/SectionFeature.js";
import SectionTeam from "../components/sections/SectionTeam.js";
import SectionProject from "../components/sections/SectionProject.js";
import SectionIntroduction from "../components/sections/SectionIntroduction.js";
import SectionContactUs from "../components/sections/SectionContactUs.js";

function Landing() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("section-page");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    var href = window.location.href.substring(
      window.location.href.lastIndexOf("#/") + 2
    );
    var hrefId = href.substring(href.lastIndexOf("#") + 1);
    if (href.lastIndexOf("#") > 0) {
      document.getElementById(hrefId).scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
    // this function is used to make the right bullets list
    // (the bellow <nav id="cd-vertical-nav">)
    // active when changeing the section on scroll
    const updateView = () => {
      var contentSections = document.getElementsByClassName("cd-section");
      var navigationItems = document
        .getElementById("cd-vertical-nav")
        .getElementsByTagName("a");

      for (let i = 0; i < contentSections.length; i++) {
        var activeSection =
          parseInt(navigationItems[i].getAttribute("data-number"), 10) - 1;
        if (
          contentSections[i].offsetTop - window.innerHeight / 2 <
          window.pageYOffset &&
          contentSections[i].offsetTop +
          contentSections[i].scrollHeight -
          window.innerHeight / 2 >
          window.pageYOffset
        ) {
          navigationItems[activeSection].classList.add("is-selected");
        } else {
          navigationItems[activeSection].classList.remove("is-selected");
        }
      }
    };

    window.addEventListener("scroll", updateView);
    return function cleanup() {
      document.body.classList.remove("section-page");
      window.removeEventListener("scroll", updateView);
    };
  });
  return (
    <>
      <ColorNavbar />
      <HomePageHeader />
      <div className="section-space" />
      <SectionIntroduction />
      <SectionHeader />
      <SectionFeature />
      {/* <div
        className="subscribe-line subscribe-line-transparent"
        style={{
          backgroundImage:
            "url(" + require("assets/img/landing/voda.jpg") + ")",
          height: "600px"
        }}
      >
      </div> */}
      <SectionProject />
      {/* <div
        className="subscribe-line subscribe-line-transparent"
        style={{
          backgroundImage:
            "url(" + require("assets/img/landing/redbull.jpg") + ")",
          height: "600px"
        }}
      ></div> */}
      <SectionTeam />
      <SectionContactUs />
      <nav id="cd-vertical-nav">
        <ul>
          <li>
            <a
              data-number="1"
              href="#home"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("home").scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "nearest",
                });
              }}
            >
              <span className="cd-dot" />
              <span className="cd-label">Home</span>
            </a>
          </li>
          <li>
            <a
              data-number="2"
              href="#portfolio"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("portfolio").scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "nearest",
                });
              }}
            >
              <span className="cd-dot" />
              <span className="cd-label">Who are we?</span>
            </a>
          </li>
          <li>
            <a
              data-number="3"
              href="#events"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("events").scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "nearest",
                });
              }}
            >
              <span className="cd-dot" />
              <span className="cd-label">Events</span>
            </a>
          </li>
          <li>
            <a
              data-number="4"
              href="#features"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("features").scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "nearest",
                });
              }}
            >
              <span className="cd-dot" />
              <span className="cd-label">What we offer?</span>
            </a>
          </li>
          {/* <li>
            <a
              data-number="5"
              href="#testimonials"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("testimonials").scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "nearest",
                });
              }}
            >
              <span className="cd-dot" />
              <span className="cd-label">Testimonials</span>
            </a>
          </li> */}
          <li>
            <a
              data-number="5"
              href="#projects"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("projects").scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "nearest",
                });
              }}
            >
              <span className="cd-dot" />
              <span className="cd-label">Projects</span>
            </a>
          </li>
          <li>
            <a
              data-number="6"
              href="#teams"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("teams").scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "nearest",
                });
              }}
            >
              <span className="cd-dot" />
              <span className="cd-label">Teams</span>
            </a>
          </li>
          <li>
            <a
              data-number="7"
              href="#contact-us"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById("contact-us").scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "nearest",
                });
              }}
            >
              <span className="cd-dot" />
              <span className="cd-label">Contact Us</span>
            </a>
          </li>
        </ul>
      </nav>
    </>
  );
}

export default Landing;